import _ from 'lodash'

const isLoading = (state) => _.get(state, 'loading')
const directories = (state) => _.get(state, 'directories')
const directory = (state) => _.get(state, 'directory')
const pageDirectory = (state) => _.get(state, 'pageCount.directory')
const pageDirectories = (state) => _.get(state, 'pageCount.directories')
const subDirectories = (state) => _.get(state, 'subDirectories')
const pageSubDirectories = (state) => _.get(state, 'pageCount.subDirectories')

export default {
	isLoading,
	directory,
	directories,
	pageDirectories,
	pageDirectory,
	subDirectories,
	pageSubDirectories,
}
